import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common} from '../../common/common';
import ImageUploading from 'react-images-uploading';
import {useNavigate} from 'react-router-dom';
import {User} from '../../interface/user.interface';
import {FleaMarket} from "../../interface/fleaMarket.interface";
import WorkplaceComponent from "./WorkplaceComponent";
import {isMobile} from "react-device-detect";

interface State {
    fleaMarket: FleaMarket[],
    fleaMarketName: string
}

function FleaMarketRegister() {
    const [fleaMarketList, setFleaMarketList] = useState<FleaMarket[]>([]);
    const [state, setState] = useState<State>({
        fleaMarket: [],
        fleaMarketName: '',
    });

    const titleRef: any = useRef();
    const startRef: any = useRef();
    const endRef: any = useRef();

    useEffect(() => {
        getFleaMarketList();
    }, []);

    function getFleaMarketList() {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getFleaMarketList).then((value) => {
            console.log(value.data.fleaMarketList);
            setFleaMarketList(value.data.fleaMarketList);
        }).catch(reason => {
        });
    }

    function handleSave() {
        let callback = (params: {}) => {
            return axios.post(constance.api.saveFleaMarket, {
                params: {
                    title: titleRef.current.value,
                    start: startRef.current.value,
                    end: endRef.current.value,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('플리마켓 생성 완료', '', 'info');
                } else {
                    common.alert('플리마켓 생성 실패', '', 'info');
                }
                getFleaMarketList();
            })
        };
        common.confirm(
            `플리마켓을 등록하시겠습니까?`,
            `플리마켓을 등록하면 기존의 진행 중인 플리마켓은 자동으로 종료가 됩니다. 진행하시겠습니까?`,
            'warning',
            callback,
            {}
        );
    }

    function handleDelete(_id: string) {
        let callback = (params: { _id: string }) => {
            return axios.post(constance.api.deleteFleaMarket, {
                params: {
                    _id: params._id,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('플리마켓 삭제 완료', '', 'info');
                } else {
                    common.alert('플리마켓 삭제 실패', '', 'info');
                }
                getFleaMarketList();
            })
        }
        common.confirm(
            `플리마켓을 삭제하시겠습니까?`,
            ``,
            'warning',
            callback,
            {_id: _id}
        );
    }

    function handleCloseMarket(_id: string) {
        let callback = (params: { _id: string }) => {
            return axios.post(constance.api.closeFleaMarket, {
                params: {
                    _id: params._id,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('플리마켓 종료 성공', '', 'info');
                } else {
                    common.alert('플리마켓 종료 실패', '', 'info');
                }
                getFleaMarketList();
            })
        }
        common.confirm(
            `플리마켓을 종료하시겠습니까?`,
            ``,
            'warning',
            callback,
            {_id: _id}
        );
    }


    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Stack sx={{width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Box id="box"
                     sx={{
                         display: 'flex',
                         pt: 3,
                         maxWidth: config.maxWidth,
                         width: 1,
                         justifyContent: 'center',
                         alignItems: 'flex-start'
                     }}>
                    <Stack sx={{width: 0.7, height: 1, mr: 3}}>
                        <Paper sx={{width: 1, p: 2}}>
                            <Stack>
                                <Box sx={{width: 1, display: 'flex', mb: 1, borderBottom: styles.border, pb: 1}}>
                                    <Typography align={"center"} sx={{width: 0.3}}>{'플리마켓'}</Typography>
                                    <Typography align={"center"} sx={{flexGrow: 1}}>{'시작'}</Typography>
                                    <Typography align={"center"} sx={{flexGrow: 1}}>{'종료'}</Typography>
                                    <Typography align={"center"} sx={{flexGrow: 1}}>{'생성일'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{'상태'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{'종료'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{'삭제'}</Typography>
                                </Box>
                                {
                                    fleaMarketList.map((value, index) => {
                                        return (
                                            <Box key={index}
                                                 sx={{
                                                     width: 1,
                                                     display: 'flex',
                                                     alignItems: 'center',
                                                     pt: 0.5,
                                                     pb: 0.5,
                                                     borderBottom: styles.border
                                                 }}>
                                                <Typography align={"center"} sx={{
                                                    width: 0.3,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{value.title}</Typography>
                                                <Typography align={"center"} sx={{
                                                    flexGrow: 1,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{common.getTimeFormatYMD(value.start)}</Typography>
                                                <Typography align={"center"} sx={{
                                                    flexGrow: 1,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{common.getTimeFormatYMD(value.end)}</Typography>
                                                <Typography align={"center"} sx={{
                                                    flexGrow: 1,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{common.getTimeFormatYMD(value.createdAt)}</Typography>
                                                <Typography align={"center"} sx={{
                                                    width: 0.1,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{value.openYN == 'Y' ? '진행 중' : '종료'}</Typography>
                                                <Box sx={{width: 0.1, p: 0.5}}>
                                                    <Button sx={{}}
                                                            disabled={value.openYN == 'N'}
                                                            size={"small"}
                                                            color={"error"}
                                                            onClick={() => handleCloseMarket(value._id)}
                                                            variant={"contained"}>
                                                        <Typography>종료</Typography>
                                                    </Button>
                                                </Box>
                                                <Box sx={{width: 0.1, p: 0.5}}>
                                                    <Button sx={{}}
                                                            size={"small"}
                                                            color={"error"}
                                                            onClick={() => handleDelete(value._id)}
                                                            variant={"contained"}>
                                                        <Typography>삭제</Typography>
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )
                                    })
                                }
                            </Stack>
                        </Paper>
                    </Stack>
                    <Stack sx={{
                        width: 0.3,
                        maxWidth: config.maxWidth,
                        alignItems: 'center',
                    }}>
                        {/* 플리마켓 명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderBottom: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 80}}> {'플리마켓'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={titleRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>


                        {/* 시작 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderBottom: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 80}}> {'시작'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={startRef}
                                           label=""
                                           type="datetime-local"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)',}}
                                           InputLabelProps={{
                                               shrink: true,
                                           }}
                                />
                            </Box>
                        </Box>

                        {/* 종료 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 80}}> {'종료'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={endRef}
                                           label=""
                                           type="datetime-local"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)',}}
                                           InputLabelProps={{
                                               shrink: true,
                                           }}
                                />
                            </Box>
                        </Box>


                        <Box sx={{mt: 2}}>
                            <Button onClick={handleSave}
                                    variant={'contained'}>
                                <Typography> {'등록'}</Typography>
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
};

export default FleaMarketRegister;
